import { Paper, Typography, CircularProgress, Box } from '@mui/material'
import { useGetSegmentTopCategoryQuery } from 'store/dashboard'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import HorizontalBarList from './HorizontalBarList'

const CHART_COLORS = [
  '#F0A500',
  '#7B68EE',
  '#20B2AA',
  '#FF6B6B',
  '#4A90D9',
  '#FFD93D',
  '#6BCB77',
  '#4D96FF',
  '#FF8C00',
  '#002C5F'
]

const paperSx = {
  p: 2,
  height: '100%',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  boxShadow: 'none'
}

export const SegmentAnalysisTopCategoryChart = () => {
  const { startDate, endDate } = useTimeRange()
  const { data, isLoading, isError, refetch, isFetching } = useGetSegmentTopCategoryQuery({
    startDate,
    endDate
  })
  const categories = data?.categories || []

  return (
    <Paper sx={paperSx} elevation={0}>
      <ChartTitle
        right={
          <Typography variant='caption' sx={{ color: 'text.secondary' }}>
            by Claimed Count
          </Typography>
        }
        tooltip='Display claim performance across different voucher segments'
      >
        Top Category
      </ChartTitle>
      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : categories.length === 0 ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <HorizontalBarList
          data={[...categories]
            .sort((a, b) => b.count - a.count)
            .map((c) => ({
              label: c.name,
              percentage: c.percentage,
              icon: c.icon
            }))}
          colors={CHART_COLORS}
          showIcons
          iconSize={18}
        />
      )}
    </Paper>
  )
}

export default SegmentAnalysisTopCategoryChart
